export default angular
  .module("LoginCtrl", ["ui.router", "ui.bootstrap"])
  .controller("LoginController", [
    "$scope",
    "$http",
    "$state",
    "$stateParams",
    "$rootScope",
    "$location",
    function ($scope, $http, $state, $stateParams, $rootScope, $location) {
      $scope.errorMessage =
        $location.search().fail
          ? "Login failed because you do not have access rights defined for this application."
          : undefined;

      $scope.login = function () {
        $scope.errorMessage = "";

        const user = {
          username: $scope.username,
          password: $scope.password,
        };

        $http
          .post("/login", user)
          .success((data) => {
            // Logged user in
            $rootScope.loggedIn = true;
            $rootScope.loggedUser = data;
            // Reset possible earlier authentication failure
            $rootScope.authenticationFailure = false;

            $state.go("secured.main");
          })
          .error(() => {
            // Show error msg since login failed
            $scope.errorMessage = "Login failed!";
            $rootScope.loggedUser = null;
          });
      };
    },
  ]);
